const parseSearchParams = ( searchParams ) => {
  let no = {}

  for ( let entry of searchParams.entries() ) {
    const [ key, value ] = entry

    no[ key ] = value
  }

  if ( no.with )
    no.with = { $in: JSON.parse( no.with ) }

  if ( no.level )
    no.level = { $in: JSON.parse( no.level ) }

  return no
}

export default parseSearchParams
